export default {
    name: 'q-grid',
    props: {
        type: {
            type: String,
            default: 'rooms-grid'
        },
        header: {
            type: String,
            required: false
        },
        size: {
            type: String,
            default: 'small'
        },
        items: {
            type: [String, Array, Object],
            default: ''
        },
        color: {
            type: String,
            default: ''
        },
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        sizeClass() {
            if (this.size) {
                return `${this.size}-grid`;
            }
        }
    },
    methods: {
        selectGridItem(item) {
            this.$emit('currentView', this.view);
            this.$emit('selectedGridItem', item);
        }
    }
};
